import React, { useState, createContext, useEffect } from 'react'

import { Box, Button } from '@mui/material'
import Vivre from '../Vivre'
import Cortex from "../../Cortex"
import Entrypoints from "../../Entrypoints"
import { getSession } from '../../../auth'
import './styles.css'
import Loading from '../../Loading'
import BuilderMessages from './BuilderMessages'
import BuilderSearch from './BuilderSearch'
import BuilderChecktime from './BuilderChecktime'
import BuilderDescriptors from './BuilderDescriptors'

import ContentUnavailable from "../../ContentUnavailable"
import SupportAgentIcon from "@mui/icons-material/SupportAgent"
import { hasActivePlatforms } from "../../../utils/utils"
import { useMenu } from "../../../contexts/MenuContext"
import useModuleAccess from "../../../utils/useModuleAccess"

export const constructorContext = createContext()
{/* <Vivre has_voice={has_voice} /> */ }

const Options = () => {
    return ({
        agents: (<Cortex />),
        bot: (<Vivre />),
        entrypoints: (<Entrypoints />),
        msg: (<BuilderMessages />),
        search: (<BuilderSearch />),
        checktime: (<BuilderChecktime />),
        descriptors: (<BuilderDescriptors />)
    })    
}

const Buttons = {
    agents: "Agentes de IA",
    bot: 'Fluxos',
    entrypoints: "Entradas",
    msg: 'Mensagens',
    //search: 'Pesquisas',
    checktime: 'Horários de atendimento',
    descriptors: 'Descritores'
}

const Builder = ({ has_voice }) => {
    const { configurableUrls } = useMenu()
    useModuleAccess("builder")

    if (! hasActivePlatforms(getSession().profile?.enterprise?.platforms || {})) {
        return (
            <ContentUnavailable
                icon={<SupportAgentIcon />}
                title="Recurso indisponível para sua conta."
                description={
                    <a href={configurableUrls?.atendimento ? configurableUrls.atendimento : "https://solucoes.instant.com.br/kwik/"} target="_blank" rel="noopener noreferrer">
                        Para mais informações sobre o módulo de atendimento, clique aqui.
                    </a>
                }
            />
        )
    }

    const initialTab = localStorage.getItem('builder-selected-tab') ? localStorage.getItem('builder-selected-tab') : 'bot'
    const [selectedTab, setSelectedTab] = useState(initialTab)
    const [activeTab, updateActiveTab] = useState(Number(localStorage.getItem('builder-active-tab')))
    const [loading, setLoading] = useState(false)
    const enterpriseId = getSession().profile.enterprise.id

    useEffect(()=>{
        localStorage.setItem('builder-active-tab', activeTab)
    }, [activeTab])

    useEffect(()=>{
        localStorage.setItem('builder-selected-tab', selectedTab)
    }, [selectedTab])


    return (
        <constructorContext.Provider value={{ activeTab, has_voice, enterpriseId, loading, setLoading }}>
            <Loading loading={loading} />
            <Box className='BuilderContainer'>
                <Box className='BuilderSelectorContainer'>
                    {has_voice ?
                        <Box className='BuilderBotSelectorBox'>
                            <Button
                                variant={activeTab === 0 ? 'contained' : ''}
                                onClick={() => updateActiveTab(0)}
                            >
                                CHATBOT
                            </Button>
                            <Button
                                variant={activeTab === 1 ? 'contained' : ''}
                                onClick={() => updateActiveTab(1)}
                            >
                                VOZ
                            </Button>
                        </Box>
                        :
                        null}
                    <Box className='BuilderSelectorBox'>
                        {Object.entries(Buttons).map(([key, value]) => (
                            <Button
                                variant={key === selectedTab ? 'contained' : ''}
                                onClick={() => setSelectedTab(key)}>
                                {value}
                            </Button>
                        ))}
                    </Box>
                </Box>
                <Box className='BuilderContent'>
                    {Options()[selectedTab]}
                </Box>
            </Box>
        </constructorContext.Provider>
    )

}


export default Builder